/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Resume_TitleInputs */

const en_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Resume Tailoring`)
};

const de_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Lebenslauf-Anpassung`)
};

const fr_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptation de CV par IA`)
};

const es_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptación de currículum por IA`)
};

const it_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizzazione curriculum con AI`)
};

const nl_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI CV-aanpassing`)
};

const pl_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosowywanie CV z AI`)
};

const fi_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälypohjainen ansioluettelon räätälöinti`)
};

const da_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI CV-tilpasning`)
};

const sv_landing_feature_resume_title = /** @type {(inputs: Landing_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI CV-anpassning`)
};

/**
* | output |
* | --- |
* | "AI Resume Tailoring" |
*
* @param {Landing_Feature_Resume_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_resume_title = /** @type {((inputs?: Landing_Feature_Resume_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Resume_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_resume_title(inputs)
	if (locale === "fr") return fr_landing_feature_resume_title(inputs)
	if (locale === "es") return es_landing_feature_resume_title(inputs)
	if (locale === "it") return it_landing_feature_resume_title(inputs)
	if (locale === "nl") return nl_landing_feature_resume_title(inputs)
	if (locale === "pl") return pl_landing_feature_resume_title(inputs)
	if (locale === "fi") return fi_landing_feature_resume_title(inputs)
	if (locale === "da") return da_landing_feature_resume_title(inputs)
	if (locale === "sv") return sv_landing_feature_resume_title(inputs)
	return en_landing_feature_resume_title(inputs)
});